export default {
  ROLES: {
    AGENT: 'Agente',
    SUPERVISOR: 'Supervisor'
  },
  GENERAL_STATUSES: {
    ENABLED: 'Activo',
    DISABLED: 'Inactivo'
  }
};